import {post, get, put, del} from '@/api/request.js'

/**
 * 获取ocr脱敏规则
 * @param page{number} 页数
 * @param page_size{number} 每页数量
 * @param text{string} 查询关键字
 * @returns {Promise<void>}
 */
export const get_desensitization = async function (page = 1, page_size = 10, text = '') {
    return await get('/admin/desensitization', {
        params: {
            page, page_size, text
        }
    })
}

/**
 * 创建脱敏规则
 * @param text{string} 替换文本
 * @param re{string} 正则表达式
 * @returns {Promise<AxiosResponse<any>>}
 */
export const create_desensitization = async function (text, re) {
    return await post('/admin/desensitization', {
        data: {
            text, re
        }
    })
}

/**
 * 修改脱敏规则
 * @param text{string} 替换文本
 * @param re{string} 正则表达式
 * @param id{number} id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const edit_desensitization = async function (text, re, id) {
    return await put('/admin/desensitization', {
        data: {
            text, re
        },
        params: {
            id
        }
    })
}

/**
 * 删除脱敏规则
 * @param id{number} id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const delete_desensitization = async function (id) {
    return await del('/admin/desensitization', {
        params: {
            id
        }
    })
}